import "core-js/modules/es.array.push.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "menu-aside"
};
import { ref, watchEffect, watch, shallowRef } from "vue";
import { VideoCamera, Histogram, BrushFilled } from "@element-plus/icons-vue";
import { getRoot } from "@/root";
import { ERouterName, Zh_CNName } from "@/types";
import { ElMessage } from "element-plus";
import store from "@/store";
export default {
  __name: 'Aside',
  setup(__props) {
    const root = getRoot();
    const deviceSn = ref("");
    const activeIndex = ref("");

    // const emits = defineEmits(["set-show"]);

    const handleSelect = key => {
      if (key == "history") {
        store.state.isShow = !store.state.isShow;
      }
      root.$router.push(`/${key}/${deviceSn.value}`);
    };
    const handleLeave = () => {
      if (JSON.stringify(store.state.gasCalibration) != "{}") {
        return ElMessage.error("请先结束调试");
      }
      root.$router.push("/devices");
    };
    let modules = shallowRef([{
      icon: VideoCamera,
      title: Zh_CNName.LIVESTREAM,
      route: ERouterName.LIVESTREAM
    }]);
    watchEffect(() => {
      const route = root.$route;
      activeIndex.value = route.name?.toLowerCase();
      deviceSn.value = route.params?.id;
      modules.value = [{
        icon: VideoCamera,
        title: Zh_CNName.LIVESTREAM,
        route: ERouterName.LIVESTREAM
      }, {
        icon: Histogram,
        title: Zh_CNName.HISTORY,
        route: ERouterName.HISTORY
      }, {
        icon: BrushFilled,
        title: Zh_CNName.COLORS,
        route: ERouterName.COLORS
      }];
    });
    return (_ctx, _cache) => {
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_el_menu = _resolveComponent("el-menu");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_menu, {
        "default-active": activeIndex.value,
        collapse: true,
        onSelect: handleSelect,
        "background-color": _ctx.$store.state.BackgroundStatus.BackgroundColor,
        "text-color": _ctx.$store.state.BackgroundStatus.TextColor,
        "active-text-color": _ctx.$store.state.BackgroundStatus.ActiveTextColor,
        class: "el-menu-vertical-demo",
        style: {
          "border": "none"
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(modules), item => {
          return _openBlock(), _createBlock(_component_el_menu_item, {
            key: item.index,
            index: item.route,
            style: _normalizeStyle({
              '--hover-color': _ctx.$store.state.BackgroundStatus.HoverColor
            })
          }, {
            title: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
            default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(item.icon)))]),
            _: 2
          }, 1032, ["index", "style"]);
        }), 128))]),
        _: 1
      }, 8, ["default-active", "background-color", "text-color", "active-text-color"]), _createElementVNode("div", {
        class: "menu-close"
      }, [_createElementVNode("a", {
        onClick: handleLeave,
        class: "menu-close-link"
      }, _cache[0] || (_cache[0] = [_createElementVNode("i", {
        class: "iconfont icon-fanhui"
      }, null, -1), _createElementVNode("text", {
        style: {
          "font-size": "12px",
          "line-height": "1.5"
        }
      }, "退出", -1)]))])]);
    };
  }
};